export default "__VITE_ASSET__BunKQBbA__"